type SetLocaleOptions = {
  reload?: boolean
  reloadPage?: () => void
}

export function setLocale(locale: string, { reload = true, reloadPage }: SetLocaleOptions = {}) {
  if (typeof document === 'undefined' || typeof window === 'undefined') return
  const encodedLocale = encodeURIComponent(locale)
  const current = document.cookie.match(/(?:^|; )PARAGLIDE_LOCALE=([^;]*)/)?.[1]
  document.cookie = `PARAGLIDE_LOCALE=${encodedLocale}; path=/; max-age=34560000; SameSite=Lax`
  if (reload && current !== encodedLocale) (reloadPage ?? (() => window.location.reload()))()
}
